<div class="rate-source-container">
    <p>{{ 'aumico_notes_super_table_add_rate_select_source' | i18next }}</p>
    <div class="rate-source-options">
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/calendar-day-outline.svg"
            [ngClass]="{ selected: selectedOption === 'closing' }"
            (buttonClick)="onSelectedRateSourceChange('closing')"
        >
            {{ 'aumico_notes_super_table_rate_source_closing' | i18next }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/calendar-month-outline.svg"
            [ngClass]="{ selected: selectedOption === 'average' }"
            (buttonClick)="onSelectedRateSourceChange('average')"
        >
            {{ 'aumico_notes_super_table_rate_source_average' | i18next }}
        </ham-button>
        <ham-button
            size="lg"
            variant="transparent"
            icon="assets/hamIcons/search-outline.svg"
            [ngClass]="{ selected: selectedOption === 'position' }"
            (buttonClick)="onSelectedRateSourceChange('position')"
        >
            {{ 'aumico_notes_super_table_rate_source_position' | i18next }}
        </ham-button>
    </div>
</div>
